import React, { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { StyledArrow } from './CollapseArrow.styles';

export interface CollapseArrowProps {
  /** Use a smaller version for the collapse arrow. */
  small?: boolean;
  /** Use a large version for the collaps arrow. */
  large?: boolean;
  /** If the arrow is isCollapsed or not. */
  isCollapsed?: boolean;
}

const CollapseArrowDefaultProps = {
  small: true,
};

/**
 * @mode developer
 */
const CollapseArrow: FC<CollapseArrowProps> = ({ small, large, ...props }) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledArrow
      Icon={theme?.icons?.chevronDown}
      small={small}
      large={large}
      {...props}
    />
  );
};

CollapseArrow.defaultProps = CollapseArrowDefaultProps;

export default CollapseArrow;
